"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.costCenterTypeEnumArray = exports.CostCenterTypeEnum = void 0;
var CostCenterTypeEnum;
(function (CostCenterTypeEnum) {
    CostCenterTypeEnum["COST_CENTER_GROUP"] = "CostCenterGroup";
    CostCenterTypeEnum["SUB_COST_CENTER"] = "SubCostCenter";
})(CostCenterTypeEnum || (exports.CostCenterTypeEnum = CostCenterTypeEnum = {}));
exports.costCenterTypeEnumArray = Object.values(CostCenterTypeEnum);
